import React, { useState } from "react";
import "./Button.scss";

function Button({ onBtnChaghe, base }) {
  const [firstBtn, setFirstBtn] = useState("active");
  const [secondBtn, setSecondBtn] = useState("inActive");
  const [thirdBtn, setThirdBtn] = useState("inActive");
  const [hourlyBtn, setHourlyBtn] = useState("inActive");

  const baseHandler = () => {
    onBtnChaghe("Base");
    setFirstBtn("active");
    setSecondBtn("inActive");
    setThirdBtn("inActive");
    setHourlyBtn("inActive");
  };

  const peakHandler = () => {
    onBtnChaghe("Peak");
    setFirstBtn("inActive");
    setSecondBtn("active");
    setThirdBtn("inActive");
    setHourlyBtn("inActive");
  };

  const offPeakHandler = () => {
    onBtnChaghe("OffPeak");
    setFirstBtn("inActive");
    setSecondBtn("inActive");
    setHourlyBtn("inActive");
    setThirdBtn("active");
  };

  const hourlyHandler = () => {
    onBtnChaghe("Hourly");
    setFirstBtn("inActive");
    setSecondBtn("inActive");
    setThirdBtn("inActive");
    setHourlyBtn("active");
  };

  return (
    <div className="Flink-Group">
      <button
        onClick={baseHandler}
        type="button"
        className={`btn Flink-Group__green ${firstBtn}`}
      >
        Base
      </button>
      <button
        onClick={peakHandler}
        type="button"
        className={`btn Flink-Group__white ${secondBtn}`}
      >
        Peak
      </button>
      <button
        onClick={offPeakHandler}
        type="button"
        className={`btn Flink-Group__white ${thirdBtn}`}
      >
        OffPeak
      </button>
      <button
        onClick={hourlyHandler}
        type="button"
        className={`btn Flink-Group__white ${hourlyBtn}`}
      >
        Hourly
      </button>
    </div>
  );
}

export default Button;
